import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

export const CSSIconAbsolute = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export const CSSIconWrapper = styled.div`
    position: relative;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CSSIconCount = styled.div`
    position: absolute;
    height: 20px;
    border-radius: 20px;
    top: 0px;
    right: 0px;
    color: ${(props) => props.theme.color.white};
    padding: 0px ${(props) => props.theme.space.xs}px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.color.orange};
`;

export const CSSIcon = styled.div`
    width: 80%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${(props) => props.theme.space.md}px;
    background-color: ${(props) => props.theme.color.white};
    img {
        width: 80%;
    }
`;

//TODO: RENAME
export const JRCWidgetEmailsImapLevel2 = ({
    count,
    img,
    label,
    maxValue = 999,
}: {
    count: number;
    img: string;
    label: string;
    maxValue?: number;
}) => {
    const intl = useIntl();
    const formattedValue = useMemo<string>(() => {
        if (count > maxValue) {
            return `${maxValue}+`;
        }

        return `${count}`;
    }, [count, maxValue]);
    return (
        <CSSIconAbsolute>
            <CSSIconWrapper>
                <CSSIcon>
                    <img src={img} />
                </CSSIcon>
                {count !== 0 && <CSSIconCount>{formattedValue}</CSSIconCount>}
            </CSSIconWrapper>
            {intl.formatMessage({
                id: label,
            })}
        </CSSIconAbsolute>
    );
};
